import { currentUserId } from '../fe-data/selectors';

export const SET_NAVBAR_TYPE = 'SET_NAVBAR_TYPE';

export const setType = navbarType => ({
  type: SET_NAVBAR_TYPE,
  payload: navbarType
});

export const initNavbarTypeFromLocalStorage = () => (dispatch, getState) => {
  const userId = currentUserId(getState());
  const navbarType = window.localStorage.getItem(`${userId}-navbarType`) || 'jobstobedone';
  dispatch(setType(navbarType));
};

export const setNavbarType = navbarType => (dispatch, getState) => {
  const userId = currentUserId(getState());
  window.localStorage.setItem(`${userId}-navbarType`, navbarType);
  dispatch(setType(navbarType));
};
